import moment from 'moment'

export const calculateDepartureDate = (arrival, duration) => {
  const date = new Date(arrival)
  date.setDate(date.getDate() + parseInt(duration, 10))

  // Add leading zeros if neccessary
  const pad = n => (n < 10 ? `0${n}` : n)

  return `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(date.getUTCDate())}`
}

export const getNights = (arrival, departure) => moment(departure).diff(moment(arrival), 'days')

/**
 * @param {Object} results Object of results
 * @param {Array} availableNights Array of numbers where a number is the number of nights a stay spans
 */
export const findAvailableNight = (results, availableNights) => {
  if (results[availableNights[0]]) return availableNights[0]
  availableNights.shift()
  if (availableNights.length > 0) return findAvailableNight(results, availableNights)
  return null
}

export const findNextDate = (arrivals, currentDate) => {
  const currentIndex = arrivals.findIndex(date => date === currentDate)
  const hasNextIndex = currentIndex + 1 < arrivals.length
  if (hasNextIndex) {
    return arrivals[currentIndex + 1]
  }
  return false
}

// If nextDate is succeeded by fewer than four columns we have to preceed the original nextDate until we find one that is.
export const calculateNextValidDate = (arrivals, nextDate) => {
  const nextDateIndex = arrivals.findIndex(date => date === nextDate)
  if (arrivals.length - (nextDateIndex + 1) > 3) {
    return arrivals[nextDateIndex]
  }
  const previousIndex = nextDateIndex > 0 ? nextDateIndex - 1 : null
  return previousIndex === null ? arrivals[0] : calculateNextValidDate(arrivals, arrivals[previousIndex])
}
